// Teclado numérico grande pro totem (touch, sem teclado físico): só dígitos.
// Apagar fica no próprio campo (segurar limpa tudo) e o avançar é o botão
// grande do rodapé da tela — pedido do dono (09/09/2026).
import Tecla from "./Tecla";

export default function TecladoNumerico({ onDigito }) {
  const teclas = ["1", "2", "3", "4", "5", "6", "7", "8", "9"];
  const comum = "h-16 md:h-20 rounded-2xl text-3xl font-bold bg-zinc-800 text-zinc-100 hover:bg-zinc-700";
  return (
    <div className="grid grid-cols-3 gap-3 w-full max-w-md mx-auto" data-e2e="teclado-numerico">
      {teclas.map((t) => (
        <Tecla key={t} onPress={() => onDigito(t)} className={comum}>{t}</Tecla>
      ))}
      <div />
      <Tecla onPress={() => onDigito("0")} className={comum}>0</Tecla>
      <div />
    </div>
  );
}
